// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2J7K3","colCheckbox":"styles_colCheckbox__3KAav"};